export const STALE = {
  catalog: 600_000,
  profiles: 600_000,
  artifacts: 60_000,
  runs: 15_000,
  environment: 30_000,
  me: 300_000,
  users: 30_000,
  stats: 60_000,
  audit: 30_000,
} as const;

export const qk = {
  health: () => ["runtime", "health"] as const,
  version: () => ["runtime", "version"] as const,
  environment: () => ["environment"] as const,
  catalogTests: () => ["catalog", "tests"] as const,
  catalogTest: (id: string) => ["catalog", "test", id] as const,
  profiles: () => ["profiles", "list"] as const,
  profile: (id: string) => ["profiles", "detail", id] as const,
  releases: (agent: string) => ["releases", agent] as const,
  artifacts: (f: object = {}) => ["artifacts", "list", f] as const,
  artifact: (id: string) => ["artifacts", "detail", id] as const,
  resolution: (id: string) => ["artifacts", "resolution", id] as const,
  runs: (f: object = {}) => ["runs", "list", f] as const,
  run: (id: string) => ["runs", "detail", id] as const,
  runEvents: (id: string) => ["runs", "events", id] as const,
  runShare: (id: string) => ["runs", "share", id] as const,
  sharedRun: (id: string) => ["shared", "run", id] as const,
  sharedRuns: (f: object = {}) => ["shared", "runs", f] as const,
  preview: (body: object) => ["runs", "preview", body] as const,
  report: (id: string) => ["runs", "report", id] as const,
  reportMarkdown: (id: string) => ["runs", "report-md", id] as const,
  bugReport: (id: string) => ["executions", "bug-report", id] as const,
  execution: (id: string) => ["executions", "detail", id] as const,
  requests: (id: string, f: object = {}) => ["executions", "requests", id, f] as const,
  request: (id: string, requestId: string) => ["executions", "request", id, requestId] as const,
  logs: (id: string, f: object) => ["executions", "logs", id, f] as const,
  stats: (range: string) => ["stats", range] as const,
  localAudit: (f: object = {}) => ["audit", "local", f] as const,
  me: () => ["me"] as const,
  users: (f: object = {}) => ["users", "list", f] as const,
  user: (id: string) => ["users", "detail", id] as const,
  usersSummary: () => ["users", "summary"] as const,
  adminAudit: (f: object = {}) => ["audit", "admin", f] as const,
  aiSettings: () => ["settings", "ai"] as const,
  jiraSettings: () => ["settings", "jira"] as const,
  jiraProjects: (q: string) => ["integrations", "jira", "projects", q] as const,
  jiraIssueTypes: (projectKey: string) => ["integrations", "jira", "issue-types", projectKey] as const,
};
